import { render, staticRenderFns } from "./AccountEventTable.vue?vue&type=template&id=85d25bbc"
import script from "./AccountEventTable.vue?vue&type=script&lang=js"
export * from "./AccountEventTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports